/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardCctScreeningDto } from './DashboardCctScreeningDto';
import {
    DashboardCctScreeningDtoFromJSON,
    DashboardCctScreeningDtoFromJSONTyped,
    DashboardCctScreeningDtoToJSON,
} from './DashboardCctScreeningDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardCctScreeningDtoPaginatedResults
 */
export interface DashboardCctScreeningDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardCctScreeningDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardCctScreeningDto>}
     * @memberof DashboardCctScreeningDtoPaginatedResults
     */
    results?: Array<DashboardCctScreeningDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardCctScreeningDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardCctScreeningDtoPaginatedResults interface.
 */
export function instanceOfDashboardCctScreeningDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctScreeningDtoPaginatedResultsFromJSON(json: any): DashboardCctScreeningDtoPaginatedResults {
    return DashboardCctScreeningDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardCctScreeningDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctScreeningDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardCctScreeningDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardCctScreeningDtoPaginatedResultsToJSON(value?: DashboardCctScreeningDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardCctScreeningDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

